import { defaultEditorValue } from '@tunasong/models'
import type { TunaDecendant } from '@tunasong/schemas'
import { createCollaborativeDoc } from '@tunasong/sync-lib'

/** Create an yDoc string from slate nodes.  */
export const getYDocString = (id: string, nodes: TunaDecendant[]) => {
  const { yDoc } = createCollaborativeDoc({ id, nodes })
  return yDoc
}

export const getYDocBinary = (id: string, nodes: TunaDecendant[]) => {
  const { yDocAsUpdates } = createCollaborativeDoc({ id, nodes })
  return yDocAsUpdates
}

export const getDefaultYDocString = (id?: string) => {
  const { yDoc } = createCollaborativeDoc({ id, nodes: defaultEditorValue })
  return yDoc
}
